/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorBoardPatient from './tumor-board-patient';
import TumorBoardPatientDetail from './tumor-board-patient-detail';
import TumorBoardPatientUpdate from './tumor-board-patient-update';
import TumorBoardPatientDeleteDialog from './tumor-board-patient-delete-dialog';

const TumorBoardPatientRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorBoardPatient />} />
    <Route path="new" element={<TumorBoardPatientUpdate />} />
    <Route path=":id">
      <Route index element={<TumorBoardPatientDetail />} />
      <Route path="edit" element={<TumorBoardPatientUpdate />} />
      <Route path="delete" element={<TumorBoardPatientDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorBoardPatientRoutes;
